import React from "react";

interface ICellBoolean {
  status?: boolean;
  text: string;
}

const CellBoolean: React.FC<ICellBoolean> = (props) => {
  const { status, text } = props;

  return (
    <div className="flex items-center gap-2">
      {status ? (
        <div
          className={`h-2 w-2 rounded-full
       ${status === true ? "bg-green-500" : "bg-red-500"}
        `}
        ></div>
      ) : (
        <></>
      )}
      <p className="text-sm font-semibold text-gray-600">
        {text ? text : status ? "Ya" : "Tidak"}
      </p>
    </div>
  );
};

export default CellBoolean;
